/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { GridProps } from '@mui/material';
import { Grid } from '@mui/material';
import React from 'react';

export const RowLayout: React.FC<
  {
    plot?: React.ReactNode;
    collection?: React.ReactNode;
    parameter?: React.ReactNode;
    style?: React.ReactNode;
    dimension?: React.ReactNode;
    actions?: React.ReactNode;
  } & GridProps
> = ({ plot, collection, parameter, style, dimension, actions, ...props }) => (
  <Grid
    alignItems="center"
    container
    justifyContent="space-between"
    spacing={2}
    {...props}
  >
    <Grid sx={{ width: 48 }}>{plot}</Grid>
    <Grid
      className="timeSeriesManagerCollection"
      sx={{
        width: 60,
      }}
    >
      {collection}
    </Grid>
    <Grid
      className="timeSeriesManagerParameter"
      sx={{
        width: '15%',
      }}
    >
      {parameter}
    </Grid>
    <Grid
      className="timeSeriesManagerStyle"
      sx={{
        width: '25%',
      }}
    >
      {style}
    </Grid>
    <Grid className="timeseriesManagerDimension" size="grow">
      {dimension}
    </Grid>
    <Grid className="timeSeriesManagerActions" sx={{ width: 88, pr: 0.5 }}>
      {actions}
    </Grid>
  </Grid>
);
